<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import type { TagsInputRootEmits, TagsInputRootProps } from 'reka-ui';
  import { TagsInputRoot, useForwardPropsEmits } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<TagsInputRootProps & { class?: HTMLAttributes['class'] }>();
  const emits = defineEmits<TagsInputRootEmits>();

  const delegatedProps = reactiveOmit(props, 'class', 'disabled');

  const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <TagsInputRoot
    v-slot="slotProps"
    v-bind="forwarded"
    data-slot="tags-input"
    :disabled="disabled"
    :class="
      cn(
        'flex flex-wrap gap-2 items-center rounded-sm border border-input bg-background px-2 py-1 text-sm transition-[color,box-shadow] outline-none',
        'focus-within:border-ring focus-within:ring-ring/50 focus-within:ring-[2px]',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 dark:bg-input/30 aria-invalid:border-destructive',
        disabled && 'pointer-events-none opacity-50',
        props.class,
      )
    "
  >
    <slot v-bind="slotProps" />
  </TagsInputRoot>
</template>
